import { EXTENSIONS } from 'probonio-shared-ui/registry';
import { ExtensionBuilder } from 'probonio-shared-ui/registry/extension-definition';
import { BenefitActivationDialogExtensionInterface } from '../../../extension/interface/benefit-activation-dialog.extension.interface';
import { BenefitMetadataExtensionInterface } from '../../../extension/interface/benefit-metadata.extension.interface';
import { BenefitNavigationExtensionInterface } from '../../../extension/interface/benefit-navigation.extension.interface';
import { RoutesExtensionInterface } from '../../../extension/interface/routes.extension.interface';
import { ITLeasingBenefitActivationDialogExtension } from './extension/it-leasing-benefit-activation-dialog.extension';
import { ITLeasingBenefitMetadataExtension } from './extension/it-leasing-benefit-metadata.extension';
import { ITLeasingBenefitNavigationExtension } from './extension/it-leasing-benefit-navigation.extension';
import { ITLeasingRoutesExtension } from './extension/it-leasing-benefit-routes.extension';

EXTENSIONS.registerExtension(
  new ExtensionBuilder('it-leasing')
    .add(BenefitMetadataExtensionInterface, new ITLeasingBenefitMetadataExtension())
    .add(BenefitNavigationExtensionInterface, new ITLeasingBenefitNavigationExtension())
    .add(BenefitActivationDialogExtensionInterface, new ITLeasingBenefitActivationDialogExtension())
    .add(RoutesExtensionInterface, new ITLeasingRoutesExtension())
    .build(),
);
